"use strict";

import Dom from "common/Dom";
import * as handlers from "scripts/components/Overlay/handlers";
import * as handlers2 from "scripts/components/Scroll/handlers";
export const openModal = function openModal($this) {
  var targetModal = $this.attr("data-modal-btn");
  $('[data-modal="' + targetModal + '"]').addClass("is-active");
  handlers.showOverlay();
  handlers2.scrollLock();
};
export const closeModal = function closeModal() {
  handlers.hideOverlay();
  handlers2.scrollUnlock();
};
